import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dTaxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $DivisiblePricePolicy = tag => ({tag});
const Average = /* #__PURE__ */ $DivisiblePricePolicy("Average");
const MostExpensive = /* #__PURE__ */ $DivisiblePricePolicy("MostExpensive");
const ProductCategory = x => x;
const newtypeProductCategory_ = {Coercible0: () => {}};
const hasFieldProductCategory = dictHasField => dictHasField;
const eqDivisiblePricePolicy = {
  eq: x => y => {
    if (x.tag === "Average") { return y.tag === "Average"; }
    if (x.tag === "MostExpensive") { return y.tag === "MostExpensive"; }
    return false;
  }
};
const eqProductCategory = {
  eq: x => y => Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.categoryModifiers)(y.categoryModifiers) && (() => {
    if (x.defaultCrossSellingList.tag === "Nothing") { return y.defaultCrossSellingList.tag === "Nothing"; }
    if (x.defaultCrossSellingList.tag === "Just") {
      if (y.defaultCrossSellingList.tag === "Just") { return x.defaultCrossSellingList._1 === y.defaultCrossSellingList._1; }
      return false;
    }
    return false;
  })() && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.defaultPriceParameters)(y.defaultPriceParameters) && Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqInt).eq(x.divisible)(y.divisible) && (() => {
    if (x.divisiblePricePolicy.tag === "Average") { return y.divisiblePricePolicy.tag === "Average"; }
    if (x.divisiblePricePolicy.tag === "MostExpensive") { return y.divisiblePricePolicy.tag === "MostExpensive"; }
    return false;
  })() && x.name === y.name && (() => {
    if (x.packagingContainersConfig.tag === "Nothing") { return y.packagingContainersConfig.tag === "Nothing"; }
    if (x.packagingContainersConfig.tag === "Just") {
      if (y.packagingContainersConfig.tag === "Just") {
        return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqPackagingContainersConf.eq(x.packagingContainersConfig._1)(y.packagingContainersConfig._1);
      }
      return false;
    }
    return false;
  })() && (() => {
    if (x.vatRate.tag === "Nothing") { return y.vatRate.tag === "Nothing"; }
    if (x.vatRate.tag === "Just") {
      if (y.vatRate.tag === "Just") {
        if (x.vatRate._1.tag === "VatA") { return y.vatRate._1.tag === "VatA"; }
        if (x.vatRate._1.tag === "VatB") { return y.vatRate._1.tag === "VatB"; }
        if (x.vatRate._1.tag === "VatC") { return y.vatRate._1.tag === "VatC"; }
        if (x.vatRate._1.tag === "VatD") { return y.vatRate._1.tag === "VatD"; }
        if (x.vatRate._1.tag === "VatE") { return y.vatRate._1.tag === "VatE"; }
        if (x.vatRate._1.tag === "VatF") { return y.vatRate._1.tag === "VatF"; }
        if (x.vatRate._1.tag === "VatG") { return y.vatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })()
};
const ordDivisiblePricePolicy = {
  compare: x => y => {
    if (x.tag === "Average") {
      if (y.tag === "Average") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Average") { return Data$dOrdering.GT; }
    if (x.tag === "MostExpensive") {
      if (y.tag === "MostExpensive") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqDivisiblePricePolicy
};
const genericProductCategory = {to: x => x, from: x => x};
const genericDivisiblePricePolicy = {
  to: x => {
    if (x.tag === "Inl") { return Average; }
    if (x.tag === "Inr") { return MostExpensive; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Average") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "MostExpensive") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showDivisiblePricePolicy = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Average"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "MostExpensive"});
    return x => {
      if (x.tag === "Average") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "MostExpensive") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const showProductCategory = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dShow.showInt);
      const $1 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $2 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["categoryModifiers", $2(v.categoryModifiers)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "defaultCrossSellingList",
              (() => {
                if (v.defaultCrossSellingList.tag === "Just") { return "(Just " + v.defaultCrossSellingList._1 + ")"; }
                if (v.defaultCrossSellingList.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["defaultPriceParameters", $1(v.defaultPriceParameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "divisible",
              $0.show(v.divisible)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["divisiblePricePolicy", showDivisiblePricePolicy.show(v.divisiblePricePolicy)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "name",
              Data$dShow.showStringImpl(v.name)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "packagingContainersConfig",
              (() => {
                if (v.packagingContainersConfig.tag === "Just") {
                  return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainersConfig.show(v.packagingContainersConfig._1) + ")";
                }
                if (v.packagingContainersConfig.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "vatRate",
              (() => {
                if (v.vatRate.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dTaxes.showVatRate.show(v.vatRate._1) + ")"; }
                if (v.vatRate.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))([]))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "ProductCategory"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeDivisiblePricePolicy = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericDivisiblePricePolicy)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Average"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("MostExpensive"), Data$dGeneric$dRep.NoArguments)]}))(Unscramble$dEnum.defaultEnumOptions)
};
const unscrambleDecodeProductCategory = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "categoryModifiers"})({
      unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "defaultCrossSellingList"})(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "defaultPriceParameters"
    })({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "divisible"})(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Unscramble.decodeInt1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "divisiblePricePolicy"
    })(unscrambleDecodeDivisiblePricePolicy)(Unscramble.decodeRecordCons({reflectSymbol: () => "name"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "packagingContainersConfig"
    })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodePackagingContainersConfig))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "vatRate"
    })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dTaxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const boundedDivisiblePricePoli = {top: MostExpensive, bottom: Average, Ord0: () => ordDivisiblePricePolicy};
const enumDivisiblePricePolicy = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericDivisiblePricePolicy)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments})),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericDivisiblePricePolicy)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments})),
  Ord0: () => ordDivisiblePricePolicy
};
const boundedEnumDivisiblePrice = /* #__PURE__ */ (() => (
  {
    cardinality: Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))[
      "genericCardinality'"
    ],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericDivisiblePricePolicy)(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))),
    fromEnum: (() => {
      const $0 = Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments));
      return x => $0["genericFromEnum'"]((() => {
        if (x.tag === "Average") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
        if (x.tag === "MostExpensive") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
        $runtime.fail();
      })());
    })(),
    Bounded0: () => boundedDivisiblePricePoli,
    Enum1: () => enumDivisiblePricePolicy
  }
))();
const encodeDivisiblePricePolicy = {
  encode: x => {
    if (x.tag === "Average") { return "Average"; }
    if (x.tag === "MostExpensive") { return "MostExpensive"; }
    $runtime.fail();
  }
};
const encodeProductCategory = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductCategory)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "ProductCategory"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "vatRate"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dTaxes.encodeVatRate.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "packagingContainersConfig"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainersConfig.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "name"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "divisiblePricePolicy"})({
      encodeWithOptions: v => encodeDivisiblePricePolicy.encode
    }))({reflectSymbol: () => "divisible"})((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Foreign$dGeneric$dClass.intEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "defaultPriceParameters"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "defaultCrossSellingList"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "categoryModifiers"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeDivisiblePricePolicy = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericDivisiblePricePolicy)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Average"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "MostExpensive"})))
};
const decodeProductCategory = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductCategory)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ProductCategory"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "vatRate"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dTaxes.decodeVatRate.decode)})())({
    reflectSymbol: () => "packagingContainersConfig"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainersConfig.decode)})())({
    reflectSymbol: () => "name"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "divisiblePricePolicy"})({
    decodeWithOptions: v => decodeDivisiblePricePolicy.decode
  })())({reflectSymbol: () => "divisible"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Foreign$dGeneric$dClass.intDecode)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "defaultPriceParameters"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "defaultCrossSellingList"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)})())({
    reflectSymbol: () => "categoryModifiers"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $DivisiblePricePolicy,
  Average,
  MostExpensive,
  ProductCategory,
  boundedDivisiblePricePoli,
  boundedEnumDivisiblePrice,
  decodeDivisiblePricePolicy,
  decodeProductCategory,
  encodeDivisiblePricePolicy,
  encodeProductCategory,
  enumDivisiblePricePolicy,
  eqDivisiblePricePolicy,
  eqProductCategory,
  genericDivisiblePricePolicy,
  genericProductCategory,
  hasFieldProductCategory,
  newtypeProductCategory_,
  ordDivisiblePricePolicy,
  showDivisiblePricePolicy,
  showProductCategory,
  unscrambleDecodeDivisiblePricePolicy,
  unscrambleDecodeProductCategory
};
